import { Button, Flex, Heading, PlusIcon, Tooltip } from '@buffer-mono/popcorn'

import type { APIClient } from '../../hooks'
import { APIClientInfo } from '../APIClientInfo'
import { GenerateApiClientCard } from '../GenerateApiClientCard'

import styles from './APIClientSection.module.css'

import type { JSX } from 'react'

interface APIClientSectionProps {
  apiClients: APIClient[]
  maxClients: number
  canUpgradeForMore: boolean
  onCreateClient: () => void
  onEditClient: (client: APIClient) => void
  onUpgrade: () => void
  onDeleteClient: (client: APIClient) => void
}

export const APIClientSection = ({
  apiClients,
  maxClients,
  canUpgradeForMore,
  onCreateClient,
  onEditClient,
  onUpgrade,
  onDeleteClient,
}: APIClientSectionProps): JSX.Element => {
  if (apiClients.length === 0) {
    return <GenerateApiClientCard onGenerate={onCreateClient} />
  }

  const canCreateNewClient = apiClients.length < maxClients

  return (
    <Flex direction="column" gap="md" className={styles.container}>
      <div className={styles.header}>
        <Heading as="h2" size="sm">
          Clients
        </Heading>

        {canCreateNewClient ? (
          <Button variant="secondary" onClick={onCreateClient}>
            <PlusIcon /> New Client
          </Button>
        ) : canUpgradeForMore ? (
          <Button variant="secondary" onClick={onUpgrade}>
            <PlusIcon /> New Client
          </Button>
        ) : (
          <Tooltip
            content={`Maximum of ${maxClients} app clients reached`}
            side="right"
          >
            <span>
              <Button variant="secondary" disabled>
                <PlusIcon /> New Client
              </Button>
            </span>
          </Tooltip>
        )}
      </div>

      {apiClients.map((client) => (
        <APIClientInfo
          key={client.clientId}
          client={client}
          onEdit={(): void => onEditClient(client)}
          onDelete={(): void => onDeleteClient(client)}
        />
      ))}
    </Flex>
  )
}
